import { ApiBaseFront } from "../../front/api-base-front";

type Params = {
  kijshopCd: string,
  favProductId: string,
};

export class ApiPrintFavoriteProductDelete extends ApiBaseFront<{}> {
  constructor(param: Params) {
    const {
      kijshopCd,
      favProductId,
    } = param;

    super(
      'DELETE',
      `/api/v1/print/shop/${kijshopCd}/favProduct/${favProductId}`,
      'JSON',
      {},
    );
  }
}
